import store from "@/store/index";
import axios from "axios";

import {
    IS_ENABLED_GOOGLE_AUTH,
    MARKETPLACE_API_URL,
    VERSION
} from "@/common/constants";

class Http {
    constructor() {
        this.axios = axios.create();
        this.axios.defaults.baseURL = MARKETPLACE_API_URL;
        this.axios.interceptors.request.use(
            async function (config) {
                const { accessToken, tenantId, tenantWasSelected } =
                    store.state.auth;
                if (accessToken) {
                    config.headers.Authorization = `Bearer ${accessToken}`;
                }
                if (tenantWasSelected && !!tenantId) {
                    config.params = {
                        ...config.params,
                        tenantId
                    };
                }
                config.headers.Version = VERSION;
                config.headers.Source = "portal";
                return config;
            },
            function (error) {
                return Promise.reject(error);
            }
        );
    }
    static instance = new Http();

    flattenParams = (params, parentKey = "") => {
        const result = {};

        for (const key in params) {
            if (!Object.prototype.hasOwnProperty.call(params, key)) continue;

            const value = params[key];
            const newKey = parentKey ? `${parentKey}.${key}` : key;

            if (
                value !== null &&
                typeof value === "object" &&
                !Array.isArray(value) &&
                !(value instanceof Date)
            ) {
                Object.assign(result, this.flattenParams(value, newKey));
            } else {
                result[newKey] = value;
            }
        }

        return result;
    };

    processOptions = (options = {}) => {
        if (options.params) {
            return {
                ...options,
                params: this.flattenParams(options.params)
            };
        }
        return options;
    };

    get = async (url, options) => {
        await this.refreshToken();
        return this.axios.get(url, this.processOptions(options));
    };
    post = async (url, body, options = {}) => {
        await this.refreshToken();
        return this.axios.post(url, body, this.processOptions(options));
    };
    patch = async (url, body, options = {}) => {
        await this.refreshToken();
        return this.axios.patch(url, body, this.processOptions(options));
    };
    put = async (url, body, options = {}) => {
        await this.refreshToken();
        return this.axios.put(url, body, this.processOptions(options));
    };
    delete = async (url, options = {}) => {
        await this.refreshToken();
        return this.axios.delete(url, this.processOptions(options));
    };

    refreshToken = async () => {
        if (!IS_ENABLED_GOOGLE_AUTH) return;
        await store.dispatch("auth/refreshAndValidateToken");
    };
}

export default Http;
